import { render, staticRenderFns } from "./cab-service-south-goa.vue?vue&type=template&id=6c4e40f3&scoped=true"
import script from "./cab-service-south-goa.vue?vue&type=script&lang=js"
export * from "./cab-service-south-goa.vue?vue&type=script&lang=js"
import style0 from "./cab-service-south-goa.vue?vue&type=style&index=0&id=6c4e40f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4e40f3",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TaxiCard: require('/workspace/components/TaxiCard.vue').default,FaqCard: require('/workspace/components/FaqCard.vue').default})
